import React, { ReactNode } from 'react';
import { ReadMore } from '../../ReadMore';
import useScreenSize from '../../../../hooks/useScreenSize';
import { SpaceSection } from '../../SpaceSection';
import { useClient } from '../../../../hooks/useClient';
import { MobileBlock } from '../CurrentItemSections/styled';

interface CurrentItemDescProps {
  title: ReactNode;
  description: ReactNode;
}

export const CurrentItemDesc: React.FC<CurrentItemDescProps> = ({
  description,
  title
}) => {
  const { isSmall } = useScreenSize();
  const isClient = useClient();
  const showOnMobile = !isClient || isSmall;

  if (!isSmall && !description) return null;

  return (
    <SpaceSection>
      <div data-cy="cur-item-desc">
        {showOnMobile && <MobileBlock>{title}</MobileBlock>}
        {description && <ReadMore description={description} />}
      </div>
    </SpaceSection>
  );
};
